"use client";
import MobileNavigation from "@/components/app/MobileNavigation";
import PersonArea from "@/components/app/PersonArea";
import AppBody from "@/components/layout/AppBody";
import AppHeader from "@/components/layout/AppHeader";
import { Toaster } from "@/components/ui/sonner";
import { StrictMode } from "react";
import { AppProviders } from "./providers";

export default function Layout({ children }: { children: React.ReactNode }) {
  return (
    <StrictMode>
      <AppProviders>
        <AppHeader
          MobileNavigation={<MobileNavigation />}
          SearchBar={<></>}
          DesktopNavigation={<></>}
          PersonArea={<PersonArea />}
        />
        <Toaster />
        <AppBody> {children} </AppBody>
      </AppProviders>
    </StrictMode>
  );
}
